import React, { useState } from 'react';
import AddIcon from '@material-ui/icons/Add';

import ActionButton from 'components/buttons/ActionButton';

import EditLevelDialog from './EditLevelDialog';

const AddLevelButton = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <ActionButton startIcon={<AddIcon />} onClick={handleOpen}>
        Add Level
      </ActionButton>
      {open && <EditLevelDialog open={open} onClose={handleClose} />}
    </>
  );
};

export default AddLevelButton;
